export enum EFeatureKeys {
	// Advanced Capabilities
	MULTILINGUAL_SUPPORT = 'multilingualSupport',
	SET_MAX_RECIPIENT_MINUTES = 'setMaxRecipientMinutes',
	TIME_CONTROLS = 'timeControls',
	ZAPIER_INTEGRATION = 'zapierIntegration',

	// Analytics and Reporting
	ANALYTICS_TAB = 'analyticsTab',
	LOGS = 'logs',
	MAX_NOTIFICATION_RECIPIENTS = 'maxNotificationRecipients',
	POST_CALL_NOTIFICATIONS = 'postCallNotifications',
	WORKFLOW_NOTIFICATIONS = 'workflowNotifications',

	// Communication and Call Handling
	MINUTES_INCLUDED = 'minutesIncluded',
	PREMIUM_AI_MODELS = 'premiumAiModels',
	PREMIUM_VOICES = 'premiumVoices',
	SMS_CREDITS_INCLUDED = 'smsCreditsIncluded',
	STATE_OF_ART_LATENCY = 'stateOfArtLatency',
	UNLIMITED_PARALLEL_CALLS = 'unlimitedParallelCalls',

	// Knowledge and CRM
	ADVANCED_CRM = 'advancedCRM',
	KNOWLEDGE_BASE_LENGTH_PAGES = 'knowledgeBaseLengthPages',

	// Phone Numbers and Forwarding
	KEEP_YOUR_PHONE_NUMBER = 'keepYourPhoneNumber',
	PICK_YOUR_AREA_CODE = 'pickYourAreaCode',
	RECEIVE_A_STANDALONE_NUMBER = 'recieveAStandaloneNumber',

	// Support and SLA
	SUPPORT_CALLS = 'supportCalls',
	SUPPORT_SLA_WITHIN_HOURS = 'supportSLAWithInHours',

	// Webhooks
	CUSTOM_WEBHOOKS = 'customWebhooks',

	// Workflows
	API_WORKFLOWS = 'apiWorkflows',
	CALL_TRANSFER_WORKFLOWS = 'callTransferWorkflows',
	INTAKE_FORM_WORKFLOWS = 'intakeFormWorkflows',
	POST_CALL_MESSAGE = 'postCallMessage',
	TEXT_WORKFLOWS = 'textWorkflows',
	OVER_THE_PHONE_BOOK_WORKFLOWS = 'overThePhoneBookWorkflows',
}
